/**
 * Syncs selected keys from stream values to the project store.
 *
 * Replaces per-page sync hooks (syncWebsiteToStore, syncCampaignToStore, etc.)
 * with a single parameterized hook.
 *
 * Works inside any Chat.Root — uses useStreamSelector.
 */
import { useStreamSelector } from "@launch10/use-langgraph-stream";
import { syncLanggraphToStore } from "~/stores/useSyncProject";

export type SyncKey = "websiteId" | "projectId" | "brainstormId" | "campaignId";

export function useSyncToProjectStore(keys: SyncKey[]) {
  const values = useStreamSelector((s) => s.values);

  for (const key of keys) {
    syncLanggraphToStore(key, values?.[key]);
  }
}
